// extracted by mini-css-extract-plugin
export default {"wrapper":"workflowstatus_wrapper__PceRD","status":"workflowstatus_status__DVhDn"};